module.exports = ".upload .actions {\n  height: 34.444px; }\n\n.upload .error {\n  color: #e74c3c;\n  margin-bottom: 10px;\n  padding: 0 20%; }\n\n.upload .upload-progress {\n  margin-top: 10px; }\n\n.dragdrop {\n  padding: 50px 30px 50px 30px;\n  border: dashed 3px rgba(128, 128, 128, 0.2); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/file-upload/video-file-upload.component.scss
// module id = ./src/app/modules/sessions/file-upload/video-file-upload.component.scss
// module chunks = main